export default __webpack_public_path__ + "static/media/view_img4.b014b4df.png";